import React, { useState } from "react";
import { FaUserMd, FaClipboardList, FaMinus, FaPlus, FaFileMedicalAlt, FaDatabase, FaClipboardCheck, FaLaptopMedical, FaChartLine, FaBrain, FaChartPie, FaHeartbeat, FaNotesMedical, FaCogs, FaUserClock, FaDollarSign, FaNetworkWired, FaHospital, FaProcedures, FaUserShield } from "react-icons/fa";

import Medpalm from "../../../assests/Healthsoftware/consent.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
import { MdAnalytics, MdAutoGraph, MdDashboardCustomize, MdFactCheck, MdGroups, MdHealthAndSafety, MdOutlineBusinessCenter, MdPolicy, MdTimeline } from "react-icons/md";
const services = [
    {
      title: "Predictive Healthcare Analytics",
      description:
        "Leverages AI-driven machine learning models to analyze historical and real-time patient data, predicting health risks and potential complications before they arise. Identifies early warning signs for conditions such as sepsis, heart disease, and hospital readmissions, allowing healthcare providers to intervene proactively. By enabling personalized risk stratification, this technology improves early diagnosis, enhances patient outcomes, and reduces unnecessary hospital stays and costs.",
    },
    {
      title: "Clinical Data Analytics",
      description:
        "Utilizes advanced data processing techniques to analyze electronic health records (EHR), lab results, imaging reports, and patient history. Provides physicians with real-time, evidence-based insights to refine diagnoses, tailor treatment plans, and improve clinical decision-making. Enhances patient safety by identifying potential drug interactions, detecting anomalies in lab results, and supporting precision medicine initiatives, ultimately reducing diagnostic errors and treatment delays.",
    },
    {
      title: "Operational & Financial Analytics",
      description:
        "Optimizes hospital operations and financial performance through real-time data analysis. Tracks patient flow, bed occupancy, staffing efficiency, and revenue cycle management to improve resource allocation and reduce operational bottlenecks. Helps prevent revenue leakage by identifying billing discrepancies and streamlining claims processing. Data-driven forecasting assists administrators in reducing costs, maximizing efficiency, and ensuring high-quality patient care while maintaining financial sustainability.",
    },
    {
      title: "Patient Engagement & Behavioral Analytics",
      description:
        "Analyzes patient interactions with healthcare services, engagement with treatment plans, and behavioral patterns to enhance patient experience and adherence. Integrates data from patient portals, wearable devices, and mobile apps to develop personalized health strategies. Enables healthcare providers to improve communication, predict patient adherence risks, and design targeted interventions that foster better health habits, reduce hospital visits, and improve long-term outcomes.",
    },
    {
      title: "Regulatory & Compliance Analytics",
      description:
        "Ensures healthcare organizations meet regulatory requirements such as HIPAA, CMS, and FDA guidelines through continuous monitoring and analytics-driven auditing. Detects fraudulent activities, prevents data breaches, and ensures proper billing and coding compliance. By automating compliance checks and risk assessments, this solution helps organizations avoid legal penalties, enhance data security, and maintain trust with patients and stakeholders.",
    },
  ];
  

const features = [
    { icon: <FaChartPie className="text-[#2a627a] text-lg" />, text: "Real-Time Data Processing Leverage real-time data analytics for immediate insights into patient care, hospital operations, and financial performance." },
    // { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Predictive analytics for early disease detection and prevention." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Advanced Predictive Modeling - Utilize advanced algorithms and machine learning to predict patient outcomes, improve treatment protocols, and manage hospital resources more effectively." },
    { icon: <FaCogs className="text-[#2a627a] text-lg" />, text: "Customizable Dashboards-Create tailored dashboards for decision-makers to visualize critical healthcare metrics, ensuring that the right data is available at the right time." },
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Interoperability- Seamlessly integrate data from different healthcare systems, allowing for a unified view of patient data across clinical, provider, and payer systems." },
    // { icon: <FaClipboardList className="text-[#2a627a] text-lg" />, text: "Customizable analytics dashboards for healthcare administrators." }
];

const benefits = [
    { icon: <MdTimeline className="text-[#2a627a] text-lg" />, text: "Improved Patient Care- Utilize data insights to deliver personalized care and improve clinical outcomes by predicting patient needs and trends." },
    { icon: <MdHealthAndSafety  className="text-[#2a627a] text-lg" />, text: "Cost Reduction- Reduce unnecessary costs by optimizing resource usage, improving billing accuracy, and minimizing readmissions through predictive analytics." },
    { icon: <MdAutoGraph className="text-[#2a627a] text-lg" />, text: "Enhanced Operational Efficiency- Streamline operations by identifying inefficiencies and implementing data-driven improvements across hospital management and clinical workflows." },
    { icon: <MdDashboardCustomize  className="text-[#2a627a] text-lg" />, text: "Increased Compliance-Ensure your healthcare organization stays compliant with regulatory requirements by continuously monitoring performance against established standards." },
    // { icon: <FaHospital className="text-[#2a627a] text-lg" />, text: "Improves hospital performance through benchmarking and KPI tracking." },
    // { icon: <FaNetworkWired className="text-[#2a627a] text-lg" />, text: "Strengthens population health management with trend analysis." }
];
const consentItems = [
    { icon: <MdAnalytics className="text-[#2a627a] text-xl" />, text: "Predictive Analytics – Forecast patient outcomes, disease trends, and operational needs with advanced predictive models to optimize care delivery and resource allocation." },
    { icon: <MdFactCheck className="text-[#2a627a] text-xl" />, text: "Clinical Data Analysis – Utilize data from clinical systems to evaluate patient care, treatment effectiveness, and identify areas for improvement in clinical outcomes." },
    { icon: <MdOutlineBusinessCenter className="text-[#2a627a] text-xl" />, text: "Operational & Financial Analysis – Analyze operational data to improve financial performance, streamline workflows, and enhance resource management." },
    { icon: <MdGroups className="text-[#2a627a] text-xl" />, text: "Patient Engagement & Behavioral Insights – Leverage patient data to improve engagement and tailor care strategies that lead to better patient satisfaction and outcomes." },
    { icon: <MdPolicy className="text-[#2a627a] text-xl" />, text: "Regulatory & Compliance Analytics – Ensure compliance with healthcare regulations through comprehensive analytics that monitor adherence to standards and policies." },
    // { icon: <FaLaptopMedical className="text-[#2a627a] text-xl" />, text: "Population Health Analyst – Identifies trends in population health to improve public healthcare strategies." }
];

const HealthcareAnalytics = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">Healthcare Analytics  </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        Unlock data-driven insights to improve patient care, optimize operations, and enhance clinical outcomes.
                    </p>
                </div>

                {/* What is Consent? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-2xl hover:shadow-2xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Healthcare Analytics?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        Healthcare Analytics involves analyzing healthcare data to optimize hospital operations, improve patient outcomes, and enhance the decision-making process across the healthcare ecosystem. By using cutting-edge analytics tools, we help healthcare organizations predict trends, identify opportunities, and make data-driven decisions that improve both the quality and efficiency of care.


                        </p>
                    </div>
                </section>

                {/* Role of Consent Management */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 ">
                        Role of Healthcare Analytics
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {consentItems.map((item, index) => (
                            <motion.div
                                key={index}
                                className="relative z-10 bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl"
                                initial={{ opacity: 0, x: -100 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1 }}
                            >
                                <span className="text-[#2a627a] text-xl">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="relative bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl flex flex-col items-center text-center"
                                initial={{ opacity: 0, x: 20 }}
                                whileInView={{ opacity: 1, x: -10 }}
                                transition={{ duration: 1 }}
                            // viewport={{ once: true }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium mt-3">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-bg-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>
                                <span className="text-sm">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-8 w-full ">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-bg-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <div className="overflow-hidden"> <Footer /></div>
           
        </>
    );
};

export default HealthcareAnalytics;
